import useMutation from "src/hooks/useMutation";

function useProviderRemove(id) {
  return useMutation({
    path: `/api/v1/providers/${id}`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/providers`,
      shouldRevalidate: true,
    },
  });
}

export default useProviderRemove;
